var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cart-icon",
    d: "M17 20h-5a2 2 0 11-2.897-1.788L4.929 4H2a1 1 0 110-2h2.929a2 2 0 011.919 1.436L7.6 6h13.916a1.5 1.5 0 011.43 1.95l-1.883 6a1.5 1.5 0 01-1.43 1.05h-9.39l.882 3H19a2 2 0 11-2 2z"
  })));
}
export default SvgCart;